import React from 'react'

import axios from 'axios';

import { MdCancelPresentation } from "react-icons/md";
function Algo(props) {
    const algo_id=props.infos.algo_id
    const exchange_id=props.infos.exchange_id
    const instrument= props.infos.instrument
    const side= props.infos.side
    const target= props.infos.target
    const qty= props.infos.qty            
    const algo_origin= props.infos.algo_origin 
    const selectedList = props.selectedList
    const setSelected = props.setSelected

    // const addToList = (algo_id) => {
    //     setSelected((prevList) => [...prevList, algo_id]);
    //   };
    
    //   const removeFromList = (algo_id) => {
    //     setSelected((prevList) => prevList.filter(id => id !== algo_id));
    //   };
      const  abort = async () => {
        const url = `/api/cancel/cancel_algo/${algo_id}/blub/blub`
        try {
            const res = await axios.get(url, {timeout : 2000})
            
            } catch (err) {
              console.log(err)
            }
      }
  return (
    <li className="li li_state"> 
    <div className="state_span_container">
                <button className="btn state_abort_btn no_drag" onClick={() => abort(algo_id)}> <MdCancelPresentation className="cancel_icon no_drag" size={20}/></button>
                {algo_origin && algo_origin === "null" ? "" : algo_origin || ''} 
                {(side) === "BUY" || (side) === "buy" ? (
                    <span className="state_span state_instrument buy">{instrument}</span> 
                ):(
                    <span className="state_span state_instrument sell">{instrument}</span>  
                )}
                <span className="state_span">|</span> 
                <span className="state_span ">Target: {target} $</span>
                <span className="state_span">|</span> 
                <span className="state_span">current: {qty}</span>
            </div>

    </li>
  )
}

export default Algo